import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import RadioButtons from './radio-button-group';
import { builderDispatch, WebUI } from '../../_utils/ui';
import { DeliveryOption, PrintFinish } from '../prop-types';
import {
  availableFinishKeys,
  finishValue,
  availableFinishOptions,
  availableDeliveryOptionsForFinish,
  calculateSelectedFinish,
  selectedDeliveryOption,
} from '../common/finish-and-delivery-options';

const handleDeliveryChange = (deliveryOptions, value, onChange) => {
  onChange({
    delivery_option: selectedDeliveryOption(deliveryOptions, value),
  });
};

const handleFinishChange = (
  deliveryOption,
  value,
  finishesByDeliveryOption,
  onChange,
) => {
  onChange({
    finish: calculateSelectedFinish(
      deliveryOption.key,
      value,
      finishesByDeliveryOption,
    ),
  });
};

const handleShowAllPrices = () => {
  builderDispatch.dispatch({ type: WebUI.SHOW_PRINTS_PRICES });
};

const Options = (props) => {
  const {
    finishes,
    finish,
    finishesByDeliveryOption,
    deliveryOption,
    deliveryOptions,
    onChange,
    showAllPricesLink,
    hidePrintFinishes,
    newPrintsBuilderDeliveryAndFinishIcons,
  } = props;

  const activeFinishKey = finishValue(
    finish,
    availableFinishKeys(finishesByDeliveryOption, deliveryOption),
  );
  const rawFinishOptions = availableFinishOptions(
    finishes,
    availableFinishKeys(finishesByDeliveryOption, deliveryOption),
  );

  const mappedFinishOptions = rawFinishOptions.map((opt) => {
    const fullFin = finishes.find((d) => String(d.key) === String(opt.value));
    return {
      ...opt,
      iconClass:
        newPrintsBuilderDeliveryAndFinishIcons && fullFin
          ? `finish-options__${fullFin.name.toLowerCase()}`
          : '',
    };
  });

  const rawDeliveryOptions = availableDeliveryOptionsForFinish(
    deliveryOptions,
    finishesByDeliveryOption,
    finish,
    true,
  );

  const mappedDeliveryOptions = rawDeliveryOptions.map((opt) => {
    const fullOpt = deliveryOptions.find(
      (d) => String(d.key) === String(opt.value),
    );
    return {
      ...opt,
      iconClass:
        newPrintsBuilderDeliveryAndFinishIcons && fullOpt
          ? `delivery-options__horizontal__${fullOpt.type.toLowerCase()}`
          : '',
    };
  });

  return (
    <div className="options">
      <div
        className={classNames('form-group finish', {
          'd-none': hidePrintFinishes,
        })}>
        {newPrintsBuilderDeliveryAndFinishIcons && (
          <h6 className="font-weight-bold mb-2">Print Finish</h6>
        )}

        <RadioButtons
          id="option-finish"
          options={mappedFinishOptions}
          title={'Print Finish'}
          value={activeFinishKey}
          newPrintsBuilderDeliveryAndFinishIcons={
            newPrintsBuilderDeliveryAndFinishIcons
          }
          onChange={(value) =>
            handleFinishChange(
              deliveryOption,
              value,
              finishesByDeliveryOption,
              onChange,
            )
          }
        />
        <hr className={newPrintsBuilderDeliveryAndFinishIcons ? 'mt-4' : ''} />
      </div>

      <div className="form-group delivery">
        <div
          className={classNames({
            'd-flex justify-content-between align-items-baseline mb-2':
              newPrintsBuilderDeliveryAndFinishIcons,
          })}>
          <div
            aria-hidden="true"
            className={
              newPrintsBuilderDeliveryAndFinishIcons
                ? 'font-weight-bold mb-0'
                : 'mb-1'
            }>
            Delivery Method*
          </div>
          {showAllPricesLink && (
            <button
              aria-label="See Prices"
              className="btn btn-link btn-underline px-1"
              role="link"
              type="button"
              onClick={handleShowAllPrices}>
              See Prices
            </button>
          )}
        </div>
        <small className="d-block mb-3 text-muted">
          *Prices for each item will vary
        </small>

        <RadioButtons
          id="option-delivery"
          title="Delivery Method"
          name="radio-button"
          options={mappedDeliveryOptions}
          value={deliveryOption.key}
          newPrintsBuilderDeliveryAndFinishIcons={
            newPrintsBuilderDeliveryAndFinishIcons
          }
          onChange={(value) =>
            handleDeliveryChange(deliveryOptions, value, onChange)
          }
        />
      </div>
      <hr />
    </div>
  );
};

Options.propTypes = {
  finishes: PropTypes.arrayOf(PrintFinish),
  finish: PrintFinish.isRequired,
  finishesByDeliveryOption: PropTypes.objectOf(PropTypes.arrayOf(PrintFinish))
    .isRequired,
  deliveryOption: DeliveryOption.isRequired,
  deliveryOptions: PropTypes.arrayOf(DeliveryOption).isRequired,
  showAllPricesLink: PropTypes.bool,
  hidePrintFinishes: PropTypes.bool,
  newPrintsBuilderDeliveryAndFinishIcons: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

Options.defaultProps = {
  finishes: [],
  showAllPricesLink: false,
  hidePrintFinishes: false,
  newPrintsBuilderDeliveryAndFinishIcons: false,
};

export default Options;
